var _excluded = ["fillMode"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { TileLayout as KendoTileLayout } from '@progress/kendo-react-layout';
var StyledTileLayout = styled(_ref => {
  var {
      fillMode
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(KendoTileLayout, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n    "])), ['flat', 'outline'].includes(props.fillMode) && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            .k-tilelayout-item {\n                background: transparent;\n                ", "\n\n            }\n        "])), props.fillMode === 'flat' && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                    border: none;\n                "]))))));

/**
 * The KendoReact TileLayout component is based on the two-dimensional CSS Grid
 * and is able to display content in tiles. They can be resized and reordered
 * as desired by the user.
 * The component features draggable and resizable items (tiles), static ones,
 * various auto flows, fixed widths and heights, configurable number of columns,
 * and many more.
 */
var TileLayout = props => /*#__PURE__*/React.createElement(StyledTileLayout, props);
TileLayout.defaultProps = {
  autoFlow: 'column',
  className: undefined,
  columnWidth: undefined,
  columns: undefined,
  dataItemKey: undefined,
  dir: undefined,
  fillMode: 'solid',
  gap: undefined,
  id: undefined,
  ignoreDrag: undefined,
  items: undefined,
  onReposition: undefined,
  positions: undefined,
  rowHeight: undefined,
  style: undefined
};
TileLayout.propTypes = {
  /**
   * Controls how the auto-placement algorithm works, specifying exactly how auto-placed items
   * get flowed into the TileLayout. For further reference, check grid-auto-flow CSS article.
   */
  autoFlow: PropTypes.oneOf(['column', 'row', 'column dense', 'row dense', 'unset']),
  /**
   * Sets additional classes to the TileLayout.
   */
  className: PropTypes.string,
  /**
   * Specifies the default width of the columns.
   */
  columnWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Specifies the default number of columns.
   */
  columns: PropTypes.number,
  /**
   * Represents the key field of the TileLayout item. Used for setting unique keys to the
   * TileLayout items.
   */
  dataItemKey: PropTypes.string,
  /**
   * Represents the dir HTML attribute. This is used to switch from LTR to RTL.
   */
  dir: PropTypes.string,
  /**
   * Configures the fillMode of the TextArea.
   * The available options are: 'flat' | 'outline' | 'solid' |
   */
  fillMode: PropTypes.oneOf(['flat', 'outline', 'solid']),
  /**
   * Specifies the gaps between the tiles.
   */
  gap: PropTypes.shape({
    columns: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  /**
   * Sets the id property of the root element.
   */
  id: PropTypes.string,
  /**
   * Use this callback to prevent or allow dragging of the tiles based on specific dom event.
   * Setting ignoreDrag={(e) => { return !(e.target.classList.contains("k-card-title")); }}
   * will make only the headers draggable.
   * Setting ignoreDrag={(e) => { return e.target.nodeName == "INPUT"; }} will ignore dragging
   * input elements.
   */
  ignoreDrag: PropTypes.func,
  /**
   * The collection of items that will be rendered in the TileLayout.
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    body: PropTypes.node,
    className: PropTypes.string,
    defaultPosition: PropTypes.shape({
      col: PropTypes.number,
      colSpan: PropTypes.number,
      order: PropTypes.number,
      row: PropTypes.number,
      rowSpan: PropTypes.number
    }),
    header: PropTypes.node,
    hintClassName: PropTypes.string,
    hintStyle: PropTypes.shape({}),
    item: PropTypes.node,
    reorderable: PropTypes.bool,
    resizable: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontal', 'vertical'])]),
    style: PropTypes.shape({})
  })),
  /**
   * Fires when the user repositions the tile by either dragging or resizing.
   */
  onReposition: PropTypes.func,
  /**
   * The list of tiles' positions which are used when the TileLayout is in controlled mode.
   */
  positions: PropTypes.arrayOf(PropTypes.shape({
    col: PropTypes.number,
    colSpan: PropTypes.number,
    order: PropTypes.number,
    row: PropTypes.number,
    rowSpan: PropTypes.number
  })),
  /**
   * Specifies the default height of the rows.
   */
  rowHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Sets additional CSS styles to the TileLayout.
   */
  style: PropTypes.shape({})
};
export default TileLayout;